import { ViewModel } from "binder";
import { BooleanType, DataModelClass, ClassProperty, ClassType, DataModel, FloatType, IntegerType, KnownClassType, ListType, PropertyType, StringType, VoidType, ClassFunction, FunctionArgument, ServerSideDataLoaderType, DateType } from "./structure";

export class DataModelParser{
    private _classes : Map<string,{jsonClass:any,class:DataModelClass}>;
    private _dataModel : DataModel;
    private _classList:DataModelClass[];
    constructor(dataModel:DataModel) {
        this._dataModel = dataModel;
        this._classes = new Map<string,{jsonClass:any,class:DataModelClass}>();  
        this._classList = [];
    }
    public Parse(json){
        this.loadClasses(json);
        this.defineProperties();      
        this.defineMethods();
        this._dataModel.classes.update(...this._classList)
    }

    private loadClasses(json){
        json.classes.forEach(x=>{
            let result = new DataModelClass(this._dataModel);
            result.dataModel = this._dataModel;
            result.name = x.name;
            this._classList.push(result);
            this._classes.set(result.name,{
                class : result,
                jsonClass : x
            })
        });
    }

    private defineProperties(){
        this._classes.forEach(x=>{
            let cls = x.class;
            let json = x.jsonClass;
            json.properties.forEach(element => {
                let property = new ClassProperty(cls);
                property.name = element.name;
                property.propertyType = new PropertyTypeLoader().createPropertyType(element,cls,className=>this._classes.get(className).class);
                property.shallInitialize = element.initialize ?? false;
                property.preBody = element.preBody;
                property.postBody = element.postBody;
                property.default = element.default;
                cls.addMember(property);
            });
        })
    }
    private defineMethods(){
        this._classes.forEach(x=>{
            let cls = x.class;
            let json = x.jsonClass;
            json.methods.forEach(m => {
                let method = new ClassFunction(cls);
                method.name = m.name;
                method.arguments.update(...m.arguments.map(p=>{
                    let parameter = new FunctionArgument(method);
                    parameter.name = p.name;
                    parameter.type = new PropertyTypeLoader().createPropertyType(p.type,method,className=>this._classes.get(className).class);
                    return parameter;
                }));
                method.isAsync = m.isAsync;
                method.returnType = new PropertyTypeLoader().createPropertyType(m.returnType,method,className=>this._classes.get(className).class);
                method.body = m.body;
                cls.addMember(method);
            });
        })
    }
    
}

export class PropertyTypeLoader{
    public createPropertyType(propertyJson:any,parent:ViewModel,classResolver:(string)=>any):PropertyType{
        let result : PropertyType;
        switch(propertyJson.type){
            case "string":
                result = new StringType(parent);
                break;
            case "integer":
                result = new IntegerType(parent);
                break;
            case "float":
                result = new FloatType(parent);
                break;
            case "dateTime":
                result = new DateType(parent);
                break;
            case "boolean":
                result = new BooleanType(parent);
                break;
            case "list":
                let list = new ListType(parent);
                let type = propertyJson.ofType;
                list.OfType = this.createPropertyType(type,list,classResolver);
                result = list;
                break;
            case "class":
                result = new ClassType(parent);
                break;
            case "void":
                result = new VoidType(parent);
                break;
            case "knownClass":
                let resultBuffer = new KnownClassType(parent);
                resultBuffer.ForClass =classResolver(propertyJson.forClass)
                result = resultBuffer;
                break;
            case "serverSideDataLoader":
                let resultBuffer2 = new ServerSideDataLoaderType(parent);
                resultBuffer2.functionName = propertyJson.FunctionName;
                resultBuffer2.pageSize = propertyJson.PageSize;
                result = resultBuffer2;
                break;
            case "dateTime":
                let resultBuffer3 = new DateType(parent);
                resultBuffer3.defaultValueType = propertyJson.defaultValueType;
                result = resultBuffer3;
                break;
            }
        return result;
    }
}
